import { Component, OnInit } from '@angular/core';
import { TypeWithdraw } from 'src/app/models/typeWithdraw';
import { ClientService } from 'src/app/services/client.service';
import { WithdrawService } from 'src/app/services/withdraw.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.page.html',
  styleUrls: ['./withdraw.page.scss'],
})
export class WithdrawPage implements OnInit {

  typeWithdraw: TypeWithdraw[] = [];
  bond = 0;
  balanceReal = 0.00;
  balanceBs = 0.00;
  balanceDolar = 0.00;
  coin = null;

  constructor(private withdrawService: WithdrawService,  private clientService: ClientService) {
  }

  async ngOnInit() {
    this.coin = Security.getCoin();
    this.loadWithdraw();
    this.getBalanceReal();
    this.getBalanceBs();
    this.getBalanceDolar();
  }

  async loadWithdraw() {
    this.withdrawService.getWithdrawal(this.coin).subscribe(result => {
      this.typeWithdraw = result.data;
    });
  }

  changeTypeWithdraw(event) {
    if (event === '1') {
      this.bond = 1;
    }

    if (event === '2') {
      this.bond = 2;
    }

    if (event === '3') {
      this.bond = 3;
    }
  }

  async getBalanceReal() {
    this.clientService.getBalanceReal().subscribe(result => {
      this.balanceReal = result.data;
    });
  }

  async getBalanceBs() {
    this.clientService.getBalanceBs().subscribe(result => {
      this.balanceBs = result.data;
    });
  }

  async getBalanceDolar() {
    this.clientService.getBalanceDolar().subscribe(result => {
      this.balanceDolar = result.data;
    });
  }

}
